<template>
  <div class="appointment">
    <common-layout>
      <div slot="header">
        <h3>预约管理</h3>
      </div>
      <div slot="container">
        <div class="appointment.header">
          <el-button
            type="success"
            size="mini"
            @click="openInnerModal('')"
            class="appointment.addBtn"
            >新增预约</el-button
          >
          <el-button
            type="info"
            size="mini"
            class="appointment.addBtn"
            @click="exportOut"
            :disabled="tableData.length == 0"
            >导出</el-button
          >
          <section>
            <el-input
              placeholder="请输入会议名称"
              v-model="searchValue"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
          </section>
          <div class="appointment.header.item">
            <label>类型:</label>
            <el-select
              v-model="typeVal"
              placeholder="请选择"
              @change="search"
              clearable
            >
              <el-option label="全部" value></el-option>
              <el-option
                v-for="item in typeOptions"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="appointment.header.item">
            <label>场地:</label>
            <el-select
              v-model="areaVal"
              placeholder="请选择"
              @change="search"
              clearable
            >
              <el-option label="全部" value></el-option>
              <el-option
                v-for="item in addressOptions"
                :key="item.id"
                :label="item.fieldName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="appointment.header.item">
            <label>状态:</label>
            <el-select
              v-model="statusVal"
              placeholder="请选择"
              @change="search"
              clearable
            >
              <el-option label="全部" value></el-option>
              <el-option label="审核通过" :value="1"></el-option>
              <el-option label="审核未通过" :value="2"></el-option>
              <el-option label="待审核" :value="4"></el-option>
            </el-select>
          </div>
          <div class="appointment.header.item">
            <label style="margin: 0 10px; line-height: 40px; min-width: 60px">预约来源:</label>
            <el-select
              v-model="srelease"
              clearable
              placeholder="请选择发布平台"
              @change="search"
            >
              <el-option label="双平台" :value="1" />
              <el-option label="大市场平台" :value="2" />
              <el-option label="成果交易平台" :value="3" />
            </el-select>
          </div>
          <div class="appointment.header.item">
            <el-date-picker
              v-model="dateVal[0]"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="开始日期"
              @change="search('start')"
              style="width: 40%; margin: 0 5px 0 10px"
            >
            </el-date-picker>
            <span> - </span>
            <el-date-picker
              v-model="dateVal[1]"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="结束日期"
              @change="search('end')"
              style="width: 40%; margin: 0 10px 0 5px"
            >
            </el-date-picker>
            <!-- <el-date-picker
              v-model="dateVal"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="search"
            ></el-date-picker> -->
          </div>
          
        </div>
        <div class="appointment.table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            :header-cell-style="headerStyle"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="90"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.$index + (current_page - 1) * per_page + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="fieldName"
              label="预约场地"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="会议名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="typeName"
              label="会议类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="unit"
              label="使用单位"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="number"
              label="参会人数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="people"
              label="联系人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              align="center"
            ></el-table-column>
            <el-table-column label="预约状态" align="center">
              <template slot-scope="scope">
                <el-tag type="success" v-show="scope.row.status == 1"
                  >通过</el-tag
                >
                <el-tag type="info" v-show="scope.row.status == 2"
                  >未通过</el-tag
                >
                <el-tag type="danger" v-show="scope.row.status == 4"
                  >待审核</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="预约来源" align="center">
              <template slot-scope="scope">
                {{
                  scope.row.isAchievement === 1 && scope.row.isMarket === 1
                    ? '双平台'
                    : scope.row.isMarket === 1
                    ? '大市场平台'
                    : '成果交易平台'
                }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="200">
              <template slot-scope="scope">
                <el-button
                  style="margin-bottom: 5px"
                  size="mini"
                  @click="openInnerModal(scope.row)"
                  >预约审核</el-button
                >
                <el-button
                  style="margin-bottom: 5px"
                  size="mini"
                  type="danger"
                  @click="deleteEvent(scope.row)"
                  v-show="scope.row.status != 4"
                  >再次预约</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <div class="grid-content bg-purple-light">
              <el-pagination
                @current-change="handleCurrentChange"
                :hide-on-single-page="true"
                layout="total, prev, pager, next,jumper"
                :total="total"
                :current-page.sync="current_page"
                :page-size="per_page"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </common-layout>

    <!-- 外部预约 -->
    <el-dialog
      :title="tipTitle"
      :visible.sync="dialogFormVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="innerFormRules" ref="innerFormRule">
        <el-form-item
          label="会议名称:"
          :label-width="formLabelWidth"
          class="rowItem +add-button"
          prop="name"
        >
          <el-input
            v-model="form.name"
            autocomplete="off"
            :disabled="operationType == 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="会议类型:"
          :label-width="formLabelWidth"
          class="rowItem +add-button"
          prop="typeId"
        >
          <el-select
            v-model="form.typeId"
            placeholder="请选择会议类型"
            :disabled="operationType == 'edit'"
          >
            <el-option
              v-for="(item, index) in typeOptions"
              :key="index"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button type="primary" size="mini" @click="addActityType"
            >+新增</el-button
          >
        </el-form-item>
        <el-form-item
          label="预约场地:"
          :label-width="formLabelWidth"
          class="rowItem"
          prop="fieldId"
        >
          <el-select
            v-model="form.fieldId"
            placeholder="请选择"
            :disabled="operationType == 'edit'"
            @change="siteEvent"
          >
            <el-option
              v-for="item in addressOptions"
              :key="item.id"
              :label="item.fieldName"
              :value="item.id"
              :disabled="item.isCan != 1"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="rowItem"></div>
        <el-form-item
          label="使用单位:"
          :label-width="formLabelWidth"
          class="rowItem"
          prop="unit"
        >
          <el-input
            v-model="form.unit"
            autocomplete="off"
            :disabled="operationType == 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="参会人数:"
          :label-width="formLabelWidth"
          class="rowItem"
          prop="number"
        >
          <el-input
            v-model="form.number"
            autocomplete="off"
            :disabled="operationType == 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系人:"
          :label-width="formLabelWidth"
          class="rowItem"
          prop="people"
        >
          <el-input
            v-model="form.people"
            autocomplete="off"
            :disabled="operationType == 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="联系电话:"
          :label-width="formLabelWidth"
          class="rowItem"
          prop="phone"
        >
          <el-input
            v-model="form.phone"
            autocomplete="off"
            :disabled="operationType == 'edit'"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="预约时间:"
              :label-width="formLabelWidth"
              prop="time"
            >
              <input v-model="form.time" hidden />
              <dateCanalder
                :fixedData="selectDates"
                :selectDateType="operationType"
                :isSelectDate="isSelectDate"
                @userSelectData="userSelectData"
              ></dateCanalder>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="operationType !== 'rePrview'">
          <el-form-item
            label="审核管理员:"
            :label-width="formLabelWidth"
            prop="administrator"
            class="rowItem"
          >
            <el-input
              v-model="form.administrator"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item class="rowItem" prop="status">
            <el-radio v-model="form.status" :label="1">审核通过</el-radio>
            <el-radio v-model="form.status" :label="2">审核不通过</el-radio>
          </el-form-item>
          <el-form-item
            label="原因:"
            :label-width="formLabelWidth"
            v-show="form.status == 2"
          >
            <el-input
              v-model="form.reason"
              autocomplete="off"
              placeholder="如若审核不通过 请填写原因"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="同步发布" prop="isMarket"
            :label-width="formLabelWidth" style="text-align: left">
          <el-select
            v-model="isMarket"
            placeholder="请选择"
            style="width: 100%"
            @change="formmarket"
          >
            <el-option label="双平台" :value="1" />
            <el-option label="大市场平台" :value="2" />
            <el-option label="成果交易平台" :value="3" />
          </el-select>
        </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('innerFormRule')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 添加活动类型 -->
    <el-dialog
      :visible.sync="dialogTypeVisible"
      title="活动类型"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="acTypeForm" :rules="acTypeFormRule" ref="acTypeForm">
        <el-form-item
          label="类型名称"
          :label-width="formLabelWidth"
          prop="typeName"
        >
          <el-input
            v-model="acTypeForm.typeName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTypeVisible = false">取 消</el-button>
        <el-button type="primary" @click="createActityType"
          >确 定 添 加</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import CommonLayout from "../../components/common-layout.vue";
import dateCanalder from "../../components/calendar.vue";
import "../../libs/formatDate";
import checkPhone from "../../../utils/checkPhone";
import {CheckTimeLine} from '../../utils/tool'
import {download1} from "@/utils/download";
export default {
  components: {
    CommonLayout,
    dateCanalder,
  },
  data() {
    var validateStatus = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择审核状态"));
      } else {
        if (value == 4) {
          callback(new Error("请选择审核状态"));
        }
        callback();
      }
    };
    return {
      status: 0,
      is_submit: true,
      tipTitle: "新增预约",
      acTypeForm: {
        typeName: "",
      },
      acTypeFormRule: {
        typeName: [
          {
            required: true,
            message: "请填写类型名称",
            trigger: "blur",
          },
        ],
      },
      dialogTypeVisible: false, //添加活动类型
      operationType: "add",
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      selectDates: [], //不可操作的数据
      isSelectDate: false, //是否可选择时间
      total: 20,
      current_page: 1,
      per_page: 10,
      isPass: 1,
      typeVal: "",
      areaVal: "",
      statusVal: "",
      srelease:'',
      dateVal: [],
      searchValue: "",
      dialogFormVisible: false,
      centerDialogVisible: false,
      typeOptions: [],
      addressOptions: [],
      isMarket:1,
      form: {
        name: "",
        typeId: "",
        fieldId: "",
        appointmentTime: "",
        time: "",
        unit: "",
        people: "",
        phone: "",
        number: "",
        status: 1,
        administrator: "测试人员",
        reason: "",
        startDay: "",
        endDay: "",
        isMarket: 1,
        isAchievement: 1,
      },
      innerFormRules: {
        name: [
          {
            required: true,
            message: "请输入会议名称",
            trigger: "blur",
          },
        ],
        typeId: [
          {
            required: true,
            message: "请选择会议类型",
            trigger: "change",
          },
        ],
        fieldId: [
          {
            required: true,
            message: "请选择会议室",
            trigger: "change",
          },
        ],
        time: [
          {
            type: "date",
            required: true,
            message: "请选择会议时间",
            trigger: "change",
          },
        ],
        unit: [
          {
            required: true,
            message: "请填写使用单位",
            trigger: "blur",
          },
        ],
        people: [
          {
            required: true,
            message: "请填写预约人",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "请填写参会人数",
            trigger: "blur",
          },
        ],
        administrator: [
          {
            required: true,
            message: "请填写审核人员姓名",
            trigger: "blur",
          },
        ],
        status: [
          {
            validator: validateStatus,
            trigger: "change",
            required: true,
          },
        ],
      },
      formLabelWidth: "120px",
      addDialogFormVisible: false,
      tableData: [],
      userId: "",
    };
  },

  methods: {
    //导出
    exportOut() {
      /*let url = window.urlConfig.url + "export_normal_Meeting";
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();*/
      download1(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/export-excel?category=1`, "预约.xls")
    },
    formmarket(val) {
      if (val === 1) {
        this.form.isMarket = 1;
        this.form.isAchievement = 1;
      } else if (val === 2) {
        this.form.isMarket = 1;
        this.form.isAchievement = 2;
      } else {
        this.form.isMarket = 2;
        this.form.isAchievement = 1;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!this.is_submit) {
          return;
        }
        this.is_submit = false;
        if (valid) {
          let tips =
            this.form.status == 1
              ? "恭喜您预约的场地审核通过"
              : "很遗憾的通知到您，您提交的场地预约尚未审核通过，请重新预约";
          if (this.operationType == "add" || this.operationType == "rePrview") {
            delete this.form.id;
            delete this.form.time;
            this.form.category = 1;

            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/create`, this.form)
              .then((res) => {
                if (res.code == 0) {
                  let message =
                    this.operationType == "add" ? "新建成功" : "再次预约成功";
                  this.$message.success(message);
                  this.search();
                  this.dialogFormVisible = false;
                  this.sendMessage(tips, this.form.phone);
                  this.sendSiteMessage(tips, this.userId, this.form.reason);
                } else {
                  this.$message.error(res.status);
                }
              })
              .catch((err) => {
                this.is_submit = true;
              });
          } else {
            delete this.form.time;
            if (this.status == 4) {
              this.http
                .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/update`, this.form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("编辑成功！");
                    this.search();
                    this.dialogFormVisible = false;
                    this.sendMessage(tips, this.form.phone);
                    this.sendSiteMessage(tips, this.userId, this.form.reason);
                  } else {
                    this.$message.error(res.status);
                  }
                })
                .catch((err) => {
                  this.is_submit = true;
                });
            } else {
              if (this.status == this.form.status) {
                this.dialogFormVisible = false;
              } else {
                let tip =
                  this.form.status == 1
                    ? "您预约的场地审核状态被修改,审核通过"
                    : "您预约的场地审核状态被修改,审核不通过，请重新预约";
                this.http
                  .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/update`, this.form)
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message.success("编辑成功！");
                      this.search();
                      this.dialogFormVisible = false;
                      this.sendMessage(tip, this.form.phone);
                      this.sendSiteMessage(tip, this.userId, this.form.reason);
                    } else {
                      this.$message.error(res.status);
                    }
                  })
                  .catch((err) => {
                    this.is_submit = true;
                  });
              }
            }
            // this.http.put(`Meeting/${this.form.id}`, this.form).then((res) => {
            // 	if (res.code == 0) {
            // 		this.$message.success("编辑成功！");
            // 		this.search()
            // 		this.dialogFormVisible = false;
            // 		this.sendMessage(tips,this.form.phone)
            // 		this.sendSiteMessage(tips,this.userId,this.form.reason)
            // 	} else {
            // 		this.$message.error(res.status)
            // 	}
            // })
          }
        } else {
          console.log("error submit!!");
          this.is_submit = true;
          return false;
        }
      });
    },
    // 发送短信验证码
    sendMessage(content, phone) {
      if (this.form.isMessage == 2) {
        // 前端明确表示不用  发送短信通知
        return false;
      }

      this.http
        .post("code/common_send", {
          content: content,
          phone: phone,
        })
        .then((res) => {})
        .catch((err) => {
          this.$message.warning(err.errmsg);
        });
    },
    sendSiteMessage(content, userId, reason) {
      this.http
        .post("Mail", {
          userId: userId,
          message: reason,
          title: content,
          send_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
        })
        .then((res) => {});
    },
    //场地数据
    getSiteData() {
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-field/page`, {pageSize: 1000}).then((res) => {
        this.addressOptions = res.data.data;
      });
    },
    // 会议类型
    getTypeData() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-type/page`, {pageSize: 1000})
        .then((res) => {
          this.typeOptions = res.data.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    //获取会议数据
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting/page2`, params)
      .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.current_page = res.data.current_page;
            this.total = res.data.total;
            this.per_page = res.data.per_page;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //选择页码
    handleCurrentChange(e) {
      this.current_page = e;
      let typeId = this.typeVal ? `&typeId=${this.typeVal}` : "";
      let status = this.statusVal ? `&status=${this.statusVal}` : "";
      let fieldId = this.areaVal ? `&fieldId=${this.areaVal}` : "";
      if (this.dateVal) {
        this.getData(
          `Meeting?category=1&name=${this.searchValue}&startDay=${
            this?.dateVal[0] || ""
          }&endDay=${
            this?.dateVal[1] || ""
          }${typeId}${status}${fieldId}&page=${this.current_page}${
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
          }`
        );
      } else {
        this.getData(
          `Meeting?category=1&name=${this.searchValue}${typeId}${status}${fieldId}&page=${this.current_page}${
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
          }`
        );
      }
    },
    // 打开内部预约
    async openInnerModal(row) {
      this.form = this.ResetForm({ type: true, name: "innerFormRule" });

      this.isMarket = row.isMarket;
        this.isAchievement = row.isAchievement;
      this.is_submit = true;
      this.tipTitle = "新增预约";
      this.operationType = row ? "edit" : "add";
      this.selectDates = [];
      this.dialogFormVisible = true;
      this.isMarket = 1
      if (row) {
        this.tipTitle = "预约审核";

        this.form.name = row.name;
        this.form.isMessage = row.isMessage;
        this.form.id = row.id;
        this.form.typeId = row.typeId;
        this.form.fieldId = row.fieldId;
        this.form.appointmentTime = row.appointmentTime;
        this.form.time = new Date();
        this.selectDates = this.formatDateManage(row.appointmentTime);
        this.form.unit = row.unit;
        this.form.people = row.people;
        this.form.phone = row.phone;
        this.form.status = row.status;
        this.form.administrator = row.administrator;
        this.form.reason = row.reason;
        this.form.startDay = row.startDay;
        this.form.endDay = row.endDay;
        this.form.number = row.number;
        this.userId = row.userId;
        this.form.isMarket = row.isMarket;
        this.form.isAchievement = row.isAchievement;
        this.status = JSON.parse(JSON.stringify(row.status));
        this.isMarket =
        this.form.isAchievement === 1 && this.form.isMarket === 1
          ? 1
          : this.form.isMarket === 1
          ? 2
          : 3;
      }
    },

    //处理后台返回的数据
    userSelectData(arr) {
      if (arr.length > 0) {
        this.form.appointmentTime = arr;
        this.form.time = new Date();
        this.form.startDay = arr[0].day;
        this.form.endDay = arr[arr.length - 1].day;
      } else {
        this.form.time = "";
      }
    },
    //处理时间数据格式
    formatDateManage(dateArrs) {
      var hash = {};
      var i = 0;
      var res = [];
      if (!dateArrs.length) return [];
      dateArrs.forEach(function (item) {
        var name = item.day;
        hash[name]
          ? res[hash[name] - 1].id.push(item.noon)
          : (hash[name] =
              ++i &&
              res.push({
                id: [item.noon],
                datestr: name,
              }));
      });
      let arrs = [];
      res.map((items) => {
        if (items.id.length == 1) {
          arrs.push({
            am: items.id[0] == 1,
            pm: items.id[0] == 2,
            datestr: items.datestr,
          });
        } else {
          arrs.push({
            am: items.id[0] == 1,
            pm: items.id[1] == 2,
            datestr: items.datestr,
          });
        }
      });
      return arrs;
    },
    // 得到不能预约的时间
    getuselessDate(fieldId) {
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 30);
      let _ = this;
      let params = {
        fieldId: fieldId,
        startDay: startDate.format("yyyy-MM-dd"),
        endDay: endDate.format("yyyy-MM-dd")
      }
      this.http.post(
          `${urlConfig.devUrl}apij2/admin-api/trade/meeting/if_appointment`, params
      )
        .then((res) => {
          _.selectDates = this.formatDateManage(
            JSON.stringify(res.data) === "{}" ? [] : res.data
          );

          this.isSelectDate = true;
        });
    },
    // 活动类型
    siteEvent() {
      if (this.form.fieldId) {
        this.getuselessDate(this.form.fieldId);
      }
    },
    //再次预约
    async deleteEvent(row) {
      this.is_submit = true;
      this.tipTitle = "再次预约";
      this.operationType = "rePrview";
      this.form = this.ResetForm({ type: true, name: "innerFormRule" });
      // this.selectDates =this.formatDateManage(row.appointmentTime);

      this.getuselessDate(row.fieldId);
      this.form.name = row.name;
      this.form.id = row.id;
      this.form.typeId = row.typeId;
      this.form.fieldId = row.fieldId;
      this.form.appointmentTime = row.appointmentTime;
      this.form.time = "";
      this.form.unit = row.unit;
      this.form.people = row.people;
      this.form.phone = row.phone;
      this.form.status = row.status;
      this.form.administrator = row.administrator;
      this.form.reason = row.reason;
      this.form.startDay = row.startDay;
      this.form.endDay = row.endDay;
      this.form.number = row.number;
        this.form.isMarket = row.isMarket;
        this.form.isAchievement = row.isAchievement;
        this.isMarket =
        this.form.isAchievement === 1 && this.form.isMarket === 1
          ? 1
          : this.form.isMarket === 1
          ? 2
          : 3;
      this.dialogFormVisible = true;
    },
      //搜索
    search(type) {
      if (this.dateVal.filter((d) => d).length === 2) {
        let flag = CheckTimeLine(this.dateVal[0], this.dateVal[1]);

        if (flag) {
          if (type === "start") {
            this.$set(this.dateVal, 0, "");
          } else {
            this.$set(this.dateVal, 1, "");
          }

          return false;
        }
      }
      let typeId = this.typeVal ? `&typeId=${this.typeVal}` : "";
      let status = this.statusVal ? `&status=${this.statusVal}` : "";
      let fieldId = this.areaVal ? `&fieldId=${this.areaVal}` : "";
      // console.log(this.searchValue);
      if (this.dateVal) {
        this.getData(
          `Meeting?category=1&name=${this.searchValue}&startDay=${
            this?.dateVal[0] || ""
          }&endDay=${this?.dateVal[1] || ""}${typeId}${status}${fieldId}${
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
          }`
        );
      } else {
        this.getData(
          `Meeting?category=1&name=${this.searchValue}${typeId}${status}${fieldId}${
            (this.srelease ? (this.srelease === 1 ? "&isMarket=1&isAchievement=1" : (this.srelease === 2 ? "&isMarket=1&isAchievement=2" : "&isMarket=2&isAchievement=1")) : '')
          }`
        );
      }
    },
    //添加会议类型
    addActityType() {
      this.is_submit = true;
      this.dialogTypeVisible = true;
      this.acTypeForm.typeName = "";
    },
    // 创建活动类型
    createActityType() {
      if (!this.is_submit) return false;
      this.is_submit = false;
      this.$refs["acTypeForm"].validate((valid) => {
        if (valid) {
          this.http
            .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-type/create`, this.acTypeForm)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.dialogTypeVisible = false;
                this.getTypeData();
              }
            })
            .catch((error) => {
              this.is_submit = true;
              this.$message.error(res.status);
            });
        } else {
          this.is_submit = true;
        }
      });
    },
  },
  created() {
    this.ResetForm({ value: this.form });

    this.getTypeData();
    this.getSiteData();
  },
  mounted() {
    this.getData("Meeting?category=1");
  },
};
</script>
<style lang="scss">
@include component(appointment) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    > section {
      margin-right: 15px;

      @include component(el-input) {
        width: 200px;
      }
    }

    @include part(item) {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > label {
        width: 80px;
        display: inline-block;
      }

      @include component(el-input) {
        width: 150px;
      }
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
  }

  @include part(addBtn) {
    &:nth-child(2) {
      margin-right: 10px;
    }

    &:nth-child(1) {
      background: #623aa2 !important;
      color: #fff;
      border: none;
    }
  }

  @include part(table) {
    margin-top: 30px;
  }

  @include component(rowItem) {
    width: 50%;
    display: inline-block;

    @include option(detailBtn) {
      @include component(el-form-item__content) {
        width: 100%;
        text-align: left;
      }
    }
  }

  @include component(el-select) {
    width: 100%;
  }

  @include component(el-radio-group) {
    width: 100%;
    text-align: left;
  }

  @include tweak(add-button) {
    @include component(el-form-item__content) {
      display: flex;
      justify-content: flex-start;
    }

    @include component(el-select) {
      width: 220px;
      margin-right: 15px;
    }
  }
}
</style>
